import _ from 'lodash';

export const gettersTypes = {
  sortedTestingRoles: '[directory] sorted testing roles',
};

const getters = {
  [gettersTypes.sortedTestingRoles]: (state) => {
    return _.sortBy(state.testingRoles || [], 'id');
  },
};

export default getters;
